import { ApiResponse } from "../../../types/api.types";
import axiosClient from "../../../utils/axios";

export const getTermsandConditions = async () => {
  try {
    const res = await axiosClient.post<
      ApiResponse<any>
    >("/cms/view", {
      label: "terms_condition",
    });

    return res.data;
  } catch (err) {
    console.warn("Error fetching privacy policy:", err);
    throw err;
  }
};